const groupName = 'Announcements';
export const announcementsSystemPermissions = {
    /**
     * Announcements management.
     * Allow to edit any announcement title, body, access, date and status.
     */
    'manage-announcements': {
        group: groupName,
        label: 'Manage Announcements',
    },
    /**
     * Allow to delete any announcement.
     */
    'delete-announcements': {
        group: groupName,
        label: 'Delete Announcements',
    },
};
